export class BlocksMigrationNamespaceContext {
    constructor(ps, manifestContextId, childPath = []) {
        this.ps = ps;
        this.manifestContextId = manifestContextId;
        this.childPath = childPath;
    }
    getQuery() {
        return this.ps.manifestsManager.getContextualManifestQuery(this.manifestContextId, this.childPath);
    }
}
//# sourceMappingURL=BlocksMigrationNamespaceContext.js.map